<template>
<section class="content">
  <div class="box box-info">
    <DataTable :value="basicAccountList" :paginator="true" :rows="8"
    class="p-datatable-responsive p-datatable-customers" data-key="id" editMode="cell">
      <Column header="S.N">
        <template #body="slotProps">
          {{slotProps.index+1}}
        </template>
      </Column>
      <Column header="Transaction Code" field="transactionCode" :sortable="true"/>

      <Column header="Account" :sortable="true" field="accountMasterId">
        <template #editor="slotProps">
            <Dropdown v-model="slotProps.data['accountMasterId']" :options="accountMasterLists" @change="updateBasicAccountSetUp(slotProps.data)"
             optionLabel="name" optionValue="id"  placeholder="Select Account" >
                <template #option="slotProps">
                    <span  :class="'product-badge status-'">{{slotProps.option.name}}</span>
                </template>
            </Dropdown>
        </template>
        <template #body="slotProps">
          {{slotProps.data.accountMasterId.name}}
        </template>
      </Column>
    </DataTable>
  </div>
</section>
</template>
<script>
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import Dropdown from 'primevue/dropdown'
export default {
  name: 'BasicAccountSetup',
  data () {
    return {
    }
  },
  computed: {
    basicAccountList() {
      return this.$store.state.users.basicAccountList
    },
    accountMasterLists() {
      return this.$store.state.accountMaster.accountMasterLists
    }
  },
  mounted() {
    this.basicAccountLists()
    this.accountMaster()
  },
  methods: {
    async basicAccountLists() {
      let response = await this.$store.dispatch('basicAccountSetupList')
      if (response.data.status === 'SUCCESS') {
        this.$toast.add({severity: 'success', summary: '', detail: response.data.message, life: 10000})
      } else {
        this.$toast.add({severity: 'error', summary: '', detail: response.data.message, life: 10000})
      }
    },
    async accountMaster() {
      let response = await this.$store.dispatch('loadOfficeAccountListForDropdown')
      if (response.data.status === 'SUCCESS') {
        // this.$toast.add({severity: 'success', summary: '', detail: response.data.message, life: 10000})
      }
    },
    async updateBasicAccountSetUp(data) {
      let basicAccount = {
        id: data.id,
        accountMasterId: data.accountMasterId
      }
      let resp = await this.$store.dispatch('updateBasicAccountSetUp', basicAccount)
      if (resp.data.status === 'SUCCESS') {
        this.$toast.add({severity: 'success', summary: '', detail: resp.data.message, life: 10000})
      }
    }
  },
  components: {
    DataTable,
    Column,
    Dropdown
  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// BasicAccountSetup.vue?4690b156